import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthPageStyles } from '../../authentication/styles';
import PaperContainer from '../../authSimplified/components/PaperContainer';
import NavButton from '../../common/components/NavButton';
import { getSupportUrl } from '../../common/utils/getSupportUrl';
import { useAppSelector } from '../../store/hook';

const AccessibilityInformationPage = (): React.JSX.Element => {
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const { classes } = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const companySettings = useAppSelector((state) => state.companySettings);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleHelp = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    const faqUrl = companySettings.faqUrl || getSupportUrl();
    window.open(faqUrl, '_blank');
  };

  const closeAccessibility = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    navigate(-1);
  };

  return (
    <PaperContainer className={classes.paper} variant="medium">
      <Box ml={-0.875}>
        <NavButton />
      </Box>
      <Box mb={3}>
        <Typography variant="h1" id="accInfo">
          {t('accessibilityAccomodationHeading')}
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography variant="body1">{t('accessibilityAccomodationPara1')}</Typography>
      </Box>

      <Box mb={3}>
        <Typography variant="body1">{t('accessibilityAccomodationAssessmentAdjustment')}</Typography>
      </Box>

      <Box mb={3}>
        <ul>
          <li>{t('accessibilityAccomodationAssessmentAdjustmentItem1')}</li>
          <li> {t('accessibilityAccomodationAssessmentAdjustmentItem2')} </li>
          <li>{t('accessibilityAccomodationAssessmentAdjustmentItem3')}</li>
          <li> {t('accessibilityAccomodationAssessmentAdjustmentItem4')} </li>
          <li> {t('accessibilityAccomodationAssessmentAdjustmentItem5')} </li>
          <li> {t('accessibilityAccomodationAssessmentAdjustmentItem6')} </li>
          <li>{t('accessibilityAccomodationAssessmentAdjustmentItem7')}</li>
        </ul>
      </Box>
      <Box mb={3}>
        <Typography variant="body1">{t('accessibilityAccomodationPara2')}</Typography>
      </Box>
      <Box mb={3}>
        <Typography variant="body1">{t('accessibilityAccomodationPara3')}</Typography>
      </Box>
      <Box mb={3}>
        <Typography variant="body1">{t('accessibilityAccomodationPara4')}</Typography>
      </Box>

      <Grid container>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <Button variant="outlined" color="secondary" onClick={handleHelp}>
                {t('visitShlSupport')}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={closeAccessibility}>
                {t('close')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PaperContainer>
  );
};

export default AccessibilityInformationPage;
